import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { ViewSwitchWrapper } from "@ryde/layout";
import { useRidesNavigation } from "@ryde/redux";
import { RidesViewTypeEnum } from "@ryde/shared";

import {
  RIDES_CALENDAR_VIEW_SWITCH_ACTIVE_ICON_COLOR,
  RIDES_CALENDAR_VIEW_SWITCH_INACTIVE_ICON_COLOR,
} from "../../calendar";

export const ViewSwitchRides: FC = () => {
  const {
    ridesPageViewType,
    navigateRidesGridMultiSelect,
    navigateRidesGridSingleSelect,
    navigateRidesKanban,
    navigateRidesCardBoard,
    navigateRidesCalendar,
  } = useRidesNavigation();
  const { t } = useTranslation();

  const switchView = useEvent((viewTo: RidesViewTypeEnum) => {
    switch (viewTo) {
      case RidesViewTypeEnum.GridMultiSelect:
        navigateRidesGridMultiSelect();
        break;
      case RidesViewTypeEnum.GridSingleSelect:
        navigateRidesGridSingleSelect();
        break;
      case RidesViewTypeEnum.CardBoard:
        navigateRidesCardBoard();
        break;
      case RidesViewTypeEnum.Calendar:
        navigateRidesCalendar();
        break;
      case RidesViewTypeEnum.Kanban:
      default:
        navigateRidesKanban();
    }
  });
  return (
    <ViewSwitchWrapper
      className={clsx("rides-view-switch", {
        ViewSwitch_Page_GridMultiSelect:
          ridesPageViewType === RidesViewTypeEnum.GridMultiSelect,
        ViewSwitch_Page_GridSingleSelect:
          ridesPageViewType === RidesViewTypeEnum.GridSingleSelect,
        ViewSwitch_Page_Kanban: ridesPageViewType === RidesViewTypeEnum.Kanban,
        ViewSwitch_Page_CardBoard:
          ridesPageViewType === RidesViewTypeEnum.CardBoard,
        ViewSwitch_Page_Calendar:
          ridesPageViewType === RidesViewTypeEnum.Calendar,
      })}
    >
      <FramerTooltip
        content={t("ui.SWITCH_TO_GRID_BULK_ACTIONS")}
        mouseEnterDelay={700}
      >
        <SVG_MUI.TableViewSVG
          className="ViewSwitch-ViewIcon ViewSwitch-TableViewIcon"
          data-e2e="rides-switch-to-grid"
          onClick={() => switchView(RidesViewTypeEnum.GridMultiSelect)}
        />
      </FramerTooltip>
      <FramerTooltip
        content={t("ui.SWITCH_TO_GRID_SINGLE_ROW_SELECT")}
        mouseEnterDelay={700}
      >
        <SVG_MUI.GridSingleSelect4SVG
          className="ViewSwitch-ViewIcon ViewSwitch-GridSingleSelectIcon"
          data-e2e="rides-switch-to-table"
          onClick={() => switchView(RidesViewTypeEnum.GridSingleSelect)}
        />
      </FramerTooltip>
      <FramerTooltip
        content={t("ui.SWITCH_TO_CARD_BOARD")}
        mouseEnterDelay={700}
      >
        <SVG_MUI.KanbanViewSVG
          className="ViewSwitch-ViewIcon ViewSwitch-CardBoardIcon"
          data-e2e="rides-switch-to-card-board"
          onClick={() => switchView(RidesViewTypeEnum.CardBoard)}
        />
      </FramerTooltip>
      <FramerTooltip content={t("ui.SWITCH_TO_KANBAN")} mouseEnterDelay={700}>
        <SVG_MUI.MuiViewKanbanIcon
          className="ViewSwitch-ViewIcon ViewSwitch-KanbanIcon"
          data-e2e="rides-switch-to-kanban"
          onClick={() => switchView(RidesViewTypeEnum.Kanban)}
        />
      </FramerTooltip>
      <FramerTooltip content={t("ui.SWITCH_TO_CALENDAR")} mouseEnterDelay={700}>
        <SVG_MUI.CalendarSwitch3SVG
          className="ViewSwitch-ViewIcon ViewSwitch-CalendarIcon"
          data-e2e="rides-switch-to-calendar"
          fill={
            ridesPageViewType === RidesViewTypeEnum.Calendar
              ? RIDES_CALENDAR_VIEW_SWITCH_ACTIVE_ICON_COLOR
              : RIDES_CALENDAR_VIEW_SWITCH_INACTIVE_ICON_COLOR
          }
          onClick={() => switchView(RidesViewTypeEnum.Calendar)}
        />
      </FramerTooltip>
    </ViewSwitchWrapper>
  );
};
